import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./protfoliomenu.css";
import { Link as Scrolllink } from "react-scroll";
import { Icon } from "@iconify/react";
import atomElectron from "@iconify/icons-eos-icons/atom-electron";
import { motion } from "framer-motion";
export function Promenu() {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark  sticky-top">
        <Scrolllink to="">
          <motion.h1
            className="nav-brand  promenuhead1 non"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 2 }}
          >
            <Icon icon={atomElectron} />
          </motion.h1>
        </Scrolllink>
        <button
          className="navbar-toggler bg-success"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse libg ml-5" id="navbarNav">
          <ul className="navbar-nav">
            <Scrolllink
              activeClass="active"
              to="/"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 2.2 }}
                className="nav-item active ml-5 promenuhead"
              >
                Home{" "}
              </motion.li>
            </Scrolllink>
            <Scrolllink
              activeClass="active"
              to="pabout"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 3 }}
                className="nav-item active ml-5 promenuhead"
              >
                About
              </motion.li>
            </Scrolllink>
            <Scrolllink
              activeClass="active"
              to="pcer"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 3.5 }}
                className="nav-item active ml-5 promenuhead"
              >
                Certifications
              </motion.li>
            </Scrolllink>
            <Scrolllink
              activeClass="active"
              to="pedu"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 4 }}
                className="nav-item active ml-5 promenuhead"
              >
                Education
              </motion.li>
            </Scrolllink>
            <Scrolllink
              activeClass="active"
              to="pskills"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 4.5 }}
                className="nav-item active ml-5 promenuhead"
              >
                Skills
              </motion.li>
            </Scrolllink>
            <Scrolllink
              activeClass="active"
              to="pcon"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              className="non"
            >
              <motion.li
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transtion={{ delay: 5 }}
                className="nav-item active ml-5 promenuhead"
              >
                Contact
              </motion.li>
            </Scrolllink>
          </ul>
        </div>
      </nav>
    </>
  );
}
